export * from "./localization/index";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/behaviors/index.js
// module id = 467
// module chunks = 0